"use strict";

module.exports = {
  API_BASE_URI: 'https://api.flow.io',
  COOKIE_SESSION_KEY: '_f60_session',
  COOKIE_SESSION_TEMPORARY_KEY: '_f60_session_temporary',
  THIRTY_MINUTES_MS: 1800000,
  HOUR_MS: 3600000,
  THIRTY_MINUTES_SECONDS: 1800,
  YEAR_SECONDS: 31536000
};


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/session/lib/config.js
// module id = 331
// module chunks = 0 1